import React from 'react'
import "./styles.css"
const data=[
    {
        id:1,
        company:"Cisco Systems",
        time:"May 2021 - July 2021",
        title:"Software Engineering Intern",
        img:"",
        links:[
            {
                id:1,
                name:"Webex",
                link:"https://www.webex.com/",

            },
            
        ],
        details: [
          "Worked on a microservice as a part of the Cisco Webex Backend team using Java Spring Boot.",
          "Developed a Grammar checker bot using Node.js for Webex."
        ],
        
    },
    {
        id:2,
        company:"IRIS NITK",
        time:"May 2019 - April 2022",
        title:"App Team Lead",
        img:"",
        links:[
            {
                id:1,
                name:"About IRIS",
                link:"https://iris.nitk.ac.in/hrms/pages/about",

            },
            {
                id:2,
                name:"Android App",
                link: "https://play.google.com/store/apps/details?id=in.ac.nitk.iris.main",
            }           
        ],
        details: [
          "IRIS is a digital portal used by 19k+ users that ensures that all administrative, academic and alumni related procedures take place methodically.",
          "Led the development and maintenance of the IRIS NITK Android App, built using Flutter with 1k+ downloads on the Google Play Store.",
          "Improved the codebase and reduced the app size by 27% .",
          "Developed multiple online and offline modules, for students and faculty using Bloc State Management."
        ],
        
    },
    {
        id:3,
        company:"Marble Ai",
        time:"Oct 2020 - Jan 2021",
        title:"Flutter App Intern",
        img:"",
        links:[
            {
                id:1,
                name:"LinkedIn Page",
                link:"https://www.linkedin.com/company/marble-ai/",

            },
        ],
        details: [
          "Developed the Flutter app from scratch using MVVM architecture and Provider State Management following core design principles.",
          "Analyzed various implementations for developing Highlighting of Digitized annotations from books.",
          "Used various algorithms to implement hierarchical structure of Notes and Keyboard Toolbar.",
        ],
        
    },
]
const Experience = () => {
    return (
      <section id="experience">
          
        <h2>Experience</h2>
        <div className="container experience__container">
        {
              data.map(({company,time,title,img, links, details})=>{
                return (
                  
                    <div>
                        <article className="experience__article">
                            <div className="experience__avatar">
                                {/* <img src={img} alt="" /> */}
                                <h2 className="experience__company">{company}</h2>
                                <h3 className="experience__title">{title}</h3>
                                <div className="experience__time">{time}</div>
                                {
                                    links.map(({id,name,link})=>{
                                        return(
                                            <div>
                                                <a href={link}>{name}</a>
                                                <br></br>
                                            </div>
                                            
                                        )
                                    })
                                }
                                
                            </div>
                            
                            <div className="experience__review">
                                <ul>
                                    {
                                    details.map((val)=>{
                                        return(
                                            <li className='experience__list-item'>&#8226; {val}</li>
                                        )
                                    })
                                    }
                                </ul>
                            </div>
                        </article>
                    </div>
                )
              })
          }
          
        </div>
      </section>
    )
  }
  
  export default Experience

